import AddIcon from '@mui/icons-material/Add';
import { Button, MenuItem, Select } from '@mui/material';

export type ActiveFilter = 'all' | 'active' | 'inactive';

interface ClinicalCardActionsProps {
  filter: ActiveFilter;
  onFilterChange: (value: ActiveFilter) => void;
  /** Accessible name for the filter, e.g. "Filter medications". */
  filterLabel: string;
  /** Display label for the inactive option — "Inactive" or "Resolved". */
  inactiveLabel?: string;
  /** Opens the domain's add flow. Inert when omitted (design-review stories). */
  onAdd?: () => void;
}

/**
 * The card's action slot — an All / Active / Inactive filter and the "+ Add"
 * entry point, shared across the Medications, Diagnoses, and Allergies cards
 * (matching the live V1 ChartBlocks). The filter narrows rows client-side;
 * "+ Add" opens the host container's add flow.
 */
export const ClinicalCardActions: React.FC<ClinicalCardActionsProps> = ({
  filter,
  onFilterChange,
  filterLabel,
  inactiveLabel = 'Inactive',
  onAdd,
}) => (
  <>
    <Select
      size="small"
      value={filter}
      onChange={(event) => onFilterChange(event.target.value)}
      SelectDisplayProps={{ 'aria-label': filterLabel }}
      sx={{ minWidth: 120 }}
    >
      <MenuItem value="all">All</MenuItem>
      <MenuItem value="active">Active</MenuItem>
      <MenuItem value="inactive">{inactiveLabel}</MenuItem>
    </Select>
    <Button
      variant="contained"
      size="small"
      startIcon={<AddIcon />}
      onClick={onAdd}
      sx={{ textTransform: 'none' }}
    >
      Add
    </Button>
  </>
);
